import React from 'react'
import PropTypes from 'prop-types'

import Styled from '../../final-transshipment.styled'

import ReportTableHead from './report-table-head.component'
import ReportTableBody from './report-table-body.component'
import ReportTableSummary from './report-table-summary.component'
import ReportTableColGroup from './report-table-colgroup.component'

const FinalTransshipmentTable = ({ data }) => {
  const {
    data_column_transshipment,
    data_final_transshipment,
    data_summary_transshipment,
  } = data

  const gearlessColumns = data_column_transshipment.gearless || []
  const gearlessSummary = data_summary_transshipment.gearless || []

  // 🧠 Convert summary array into lookup maps
  const gearlessSummaryMap = Object.fromEntries(gearlessSummary.map((item) => [item.unit_name, item.value]))

  // calculate total geared and gearless summary
  const totalGeared = data_summary_transshipment.geared
  const totalRatuGiok = data_summary_transshipment.ratu_giok
  const totalGearless = Object.values(gearlessSummaryMap).reduce((a, b) => a + b, 0)
  const totalBLQuantity = data_summary_transshipment.bl_quantity

  return (
    <Styled.Table>
      <ReportTableColGroup gearlessColumns={gearlessColumns} />
      <ReportTableHead gearlessColumns={gearlessColumns} />

      {/* SUBTOTAL ROW */}
      <ReportTableSummary
        totalGeared={totalGeared}
        totalRatuGiok={totalRatuGiok}
        totalGearless={totalGearless}
        gearlessColumns={gearlessColumns}
        totalBLQuantity={totalBLQuantity}
        gearlessSummaryMap={gearlessSummaryMap}
      />

      {/* DATA ROWS */}
      <ReportTableBody
        data={data_final_transshipment}
        gearlessColumns={gearlessColumns}
      />
    </Styled.Table>
  )
}

FinalTransshipmentTable.propTypes = {
  data: PropTypes.object.isRequired,
}

export default FinalTransshipmentTable
